import { replaceAllComplex } from '../../../../mol_function';

function SearchPagebrowserUrlToReactUrl(
  pathname: string,
  search: string,
): string {
  //debugger;
  if (pathname == 'search_page/') {
    let parts = search.split('&');

    let otherParts: string[] = [];
    let fqZZZParts: string[] = [];

    let keyword = '*';

    for (let i = 0; i < parts.length; i++) {
      if (parts[i].startsWith('fqZZZ')) {
        //let tmp = replaceAllComplex(parts[i], [{ s: '%2C', r: ',' }]);
        //fqZZZParts.push(tmp);
        let kv = parts[i].split('=');
        let value = kv[1];
        /*
          value = replaceAllComplex(value, [
            { s: '%2F', r: '___' },
            { s: '%2C', r: ',' },
          ]);
  */

        fqZZZParts.push(kv[0] + '=' + value);
      } else if (parts[i].startsWith('keyword')) {
        /*
          keyword = replaceAllComplex(decodeURI(parts[i].split('=')[1]), [
            { s: '%2C', r: ',' },
          ]);*/
        keyword = parts[i].split('=')[1];
      } else if (parts[i] != '') {
        otherParts.push(parts[i]);
      }
    }

    fqZZZParts.sort();
    otherParts.sort();

    let paramsArray = fqZZZParts;

    if (keyword != '*') {
      paramsArray.push('keyword=' + keyword);
    }

    paramsArray = paramsArray.concat(otherParts);

    let url = '/search_page/?';

    url = url + paramsArray.join('&');

    return url;
  } else if (pathname.endsWith('/s/') || pathname.endsWith('/k/')) {
    let path = pathname;
    if (path[0] == '/') path = path.substring(1);
    path = path.substring(0, path.length - 3);
    let parts = path.split('/');
    if (pathname.endsWith('/s/')) {
      let baseUrl = '/search_page/?';
      for (let i = 0; i < parts.length; i += 2) {
        let key = parts[i];
        let value = decodeURIComponent(parts[i + 1]);
        baseUrl += 'fqZZZ' + key + '=' + encodeURIComponent(value);
        if (i + 2 < parts.length) baseUrl += '&';
      }

      if (search != null && search.length > 0) baseUrl += '&' + search;
      return baseUrl;
    } else {
      let keyword = decodeURIComponent(parts[0]);
      let baseUrl = '/search_page/?keyword=' + encodeURIComponent(keyword);
      if (search != null && search != '') {
        baseUrl = baseUrl + '&' + search;
      }
      return baseUrl;
    }
  } else if (
    pathname == 'index.php' &&
    search.indexOf('main_page=advanced_search_result') != -1
  ) {
    let keyword = '*';

    let parts = search.split('&');
    let otherParts: string[] = [];
    let fqZZZParts: string[] = [];

    for (let i = 0; i < parts.length; i++) {
      if (parts[i] == 'main_page=advanced_search_result') {
        //SKIP Param
      } else if (parts[i].startsWith('fqZZZ')) {
        //let tmp = replaceAllComplex(parts[i], [{ s: '%2C', r: ',' }]);
        //fqZZZParts.push(tmp);
        let kv = parts[i].split('=');
        let value = decodeURIComponent(
          replaceAllComplex(kv[1], [{ s: '%2F', r: '___' }]),
        );

        fqZZZParts.push(kv[0] + '=' + encodeURIComponent(value));
      } else if (parts[i].startsWith('keyword')) {
        keyword = replaceAllComplex(decodeURI(parts[i].split('=')[1]), [
          { s: '%2C', r: ',' },
          { s: '+', r: ' ' },
        ]);
      } else if (parts[i] != '') {
        otherParts.push(parts[i]);
      }
    }
    fqZZZParts.sort();
    otherParts.sort();

    let paramsArray = fqZZZParts;

    if (keyword != '*') {
      paramsArray.push('keyword=' + encodeURIComponent(keyword));
    }

    paramsArray = paramsArray.concat(otherParts);

    let url = '/search_page/';

    let paramsJoin = paramsArray.join('&');

    if (paramsJoin.length > 0) url = url + '?' + paramsJoin;

    return url;
  } else debugger;
  return '';
}

function SearchPageReactUrlToApiUrl(pathname: string): string {
  //'/search_page/?'.length == 14;
  let params = pathname.substring(14);

  let parts = params.split('&');

  let query = SearchPageSortParams(parts);

  /*
  if (query.length > 0) {
    query = '?' + query;
  }
  */

  return '/SearchPage.php?' + query;
}

function SearchPageReactUrlToBrowserUrl(
  pathname: string,
  search: string,
): string {
  if (search != null && search.length >= 1 && search[0] == '?')
    search = search.substring(1);

  let otherParts: string[] = [];
  let fqZZZParts: string[] = [];
  let parts = search.split('&');

  let keyword = '*';

  for (let i = 0; i < parts.length; i++) {
    if (parts[i].startsWith('fqZZZ')) {
      let kv = parts[i].split('=');
      let key = kv[0];
      let value = decodeURIComponent(
        replaceAllComplex(kv[1], [{ s: '%2F', r: '___' }]),
      );

      fqZZZParts.push(key + '=' + encodeURIComponent(value));
    } else if (parts[i].startsWith('keyword')) {
      let valuePart = parts[i].split('=')[1];
      keyword = decodeURIComponent(valuePart);
    } else {
      otherParts.push(parts[i]);
    }
  }

  fqZZZParts.sort();

  otherParts.sort();

  let url = '/';

  for (let i = 0; i < fqZZZParts.length; i++) {
    let kv = fqZZZParts[i].split('=');
    url = url + kv[0].substr(5) + '/' + kv[1] + '/';
  }

  if (fqZZZParts.length > 0) {
    url = url + 's/';
    if (keyword != '*') {
      url = url + '?keyword=' + encodeURIComponent(keyword);
      if (otherParts.length > 0) url = url + '&';
    } else if (otherParts.length > 0) {
      url = url + '?';
    }
  } else if (keyword != '*' && keyword != '') {
    url = '/' + encodeURIComponent(keyword) + '/k/';
    if (otherParts.length > 0) url = url + '?';
  } else {
    url = '/index.php?main_page=advanced_search_result';
    if (otherParts.length > 0) url = url + '&';
  }
  url = url + otherParts.join('&');
  return url;
}

function SearchPageSortParams(parts: string[]): string {
  let pqParams: string[] = [];
  let otherParams: string[] = [];

  for (let i = 0; i < parts.length; i++) {
    if (parts[i].startsWith('fqZZZ')) {
      let kv = parts[i].split('=');
      let key = kv[0];
      let value = decodeURIComponent(
        replaceAllComplex(kv[1], [{ s: '%2F', r: '___' }]),
      );
      pqParams.push(key + '=' + encodeURIComponent(value));
    } else if (parts[i] != '') {
      if (parts[i].startsWith('keyword=')) {
        let value = parts[i].substring(8, parts[i].length);

        value = decodeURIComponent(
          replaceAllComplex(value, [{ s: '%2F', r: '___' }]),
        );

        otherParams.push('keyword=' + encodeURIComponent(value));
      } else otherParams.push(parts[i]);
    }
  }

  pqParams.sort();
  otherParams.sort();

  let result = pqParams.concat(otherParams).join('&');

  return result;
}

export {
  SearchPagebrowserUrlToReactUrl,
  SearchPageReactUrlToApiUrl,
  SearchPageReactUrlToBrowserUrl,
  SearchPageSortParams,
};
